import type { AsyncOperationEventData } from '@core/databus/DataSyncManager'
import { buildAsyncOperationEventDataBus } from '@core/databus/DataBusFactory'
import { Env } from '@core/EnvUtils'

export interface ChangeEventListener {
  onEventAdded(messages: AsyncOperationEventData): void

  onEventUpdated(messages: AsyncOperationEventData): void

  onEventRemoved(messages: AsyncOperationEventData): void
}

interface InternalEventManager {
  addChangeListener(listener: ChangeEventListener): void

  removeChangeListener(listener: ChangeEventListener): void

  removeAllChangeListener(): void
}

enum AsyncOperationEventType {
  ADDED,
  UPDATED,
  REMOVED,
}

class EventManager {
  #eventListenerMap = new Map<string, Set<ChangeEventListener>>()

  constructor() {
    buildAsyncOperationEventDataBus().addNoticeListener({
      onAdded: (messages) => {
        this.#handleMessage(messages, AsyncOperationEventType.ADDED)
      },
      onUpdated: (messages) => {
        this.#handleMessage(messages, AsyncOperationEventType.UPDATED)
      },
      onRemoved: (messages) => {
        this.#handleMessage(messages, AsyncOperationEventType.REMOVED)
      },
      onInitialized(): void {
        // TODO: to be implemented
      },
    })
  }

  #getListenerByAppId(appId: string) {
    return this.#eventListenerMap.get(appId)
  }

  #handleMessage(messages: AsyncOperationEventData[], type: AsyncOperationEventType): void {
    // TODO: 调试完成后删除所有调试日志
    console.log(messages, type)
    messages.map((item) => {
      const listenerArray = this.#getListenerByAppId(item.appId)

      if (listenerArray) {
        for (const listener of listenerArray) {
          try {
            switch (type) {
              case AsyncOperationEventType.ADDED:
                listener.onEventAdded(item)
                break
              case AsyncOperationEventType.UPDATED:
                listener.onEventUpdated(item)
                break
              case AsyncOperationEventType.REMOVED:
                listener.onEventRemoved(item)
                break
              default:
                break
            }
          } catch (error) {
            // 在调用微应用回调的时候，主动抛出捕获错误，同时在release环境让运行错误不阻塞程序运行
            if (!Env.isRelease()) {
              throw error
            }
          }
        }
      } else {
        console.log(item.appId + '的事件未注册event listener')
      }
    })
  }

  addChangeListener(appId: string, listener: ChangeEventListener): void {
    const listenerArray = this.#getListenerByAppId(appId)

    if (listenerArray) {
      if (!listenerArray.has(listener)) {
        listenerArray.add(listener)
      }
    } else {
      this.#eventListenerMap.set(appId, new Set([listener]))
      console.log(appId + '的事件注册event listener')
    }
    console.log(this.#eventListenerMap)
  }

  removeChangeListener(appId: string, listener: ChangeEventListener): void {
    const listenerArray = this.#getListenerByAppId(appId)

    if (listenerArray && listenerArray.has(listener)) {
      listenerArray.delete(listener)
    }
  }

  removeAllChangeListener(appId: string): void {
    this.#eventListenerMap.delete(appId)
  }

  getManager(appId: string): InternalEventManager {
    return {
      addChangeListener: (listener: ChangeEventListener) => this.addChangeListener(appId, listener),
      removeChangeListener: (listener: ChangeEventListener) => this.removeChangeListener(appId, listener),
      removeAllChangeListener: () => this.removeAllChangeListener(appId),
    }
  }
}

const INSTANCE = new EventManager()

export { INSTANCE }
